import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import PublicHeader from '../components/layout/PublicHeader';
import PublicFooter from '../components/layout/PublicFooter';
import { FiHelpCircle } from 'react-icons/fi';

const PublicLayout = ({ children }) => {
  const location = useLocation();
  const isHelpPage = location.pathname === '/help';

  // Pages that manage their own footer as a horizontal slide
  const horizontalPaths = ['/about', '/integrations', '/contact'];
  const isHorizontalPage = horizontalPaths.includes(location.pathname);

  return (
    <div id="public-layout-scroll-container" className="flex flex-col h-screen print:h-auto overflow-y-auto overflow-x-hidden print:overflow-visible print:block bg-charcoal-50 dark:bg-charcoal-900 font-sans text-charcoal-900 dark:text-charcoal-100 transition-colors duration-200 relative">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 z-[9999] px-4 py-2 bg-white dark:bg-charcoal-800 text-charcoal-900 dark:text-white rounded-md shadow-lg font-medium border border-charcoal-200 dark:border-charcoal-700 transition-all">
        Skip to content
      </a>
      <Toaster position="top-right" />
      <PublicHeader />
      {/*
         For horizontal pages, we constrain height to calc(100vh - header) to prevent body scroll
         and allow the internal horizontal scroll to take over.
         For standard pages, we allow flex-grow to expand naturally.
      */}
      <main id="main-content" className={`flex-grow ${isHorizontalPage ? 'h-[calc(100vh-64px)]' : ''}`}>
        {children || <Outlet />}
      </main>

      {!isHorizontalPage && <PublicFooter />}

    </div>
  );
};

export { PublicLayout };
export default PublicLayout;
